import React from "react";
import { Dropzone, FileItem } from "dropzone-ui";
import { Button, Col, Row } from 'react-bootstrap'

function DropFile(props) {
  return (
        <Row>  
            <Col sm="8" md="8" xl="12" className="p-4">
                <Dropzone
                    id="myDropzoneElementId"
                    minWidth={"400px"}
                    //clickable={false}
                    header={false}
                    footer={false}
                    behaviour={"replace"}
                    maxFiles={1}
                    //accept={".xlsx"}
                    //label={"Ovdje stavite svoje dokumente"}
                    style={{ minWidth: "500px" }}
                    onChange={props.updateFiles}
                    value={props.files}
                >
                {props.files.map((file, index) => (    
                    <div key={index}>                    
                        <FileItem key={index} {...file} onDelete={props.removeFile} />
                    
                        <span> Number of records: {props.selectedFile.length}</span>
                    </div>
                ))}
                </Dropzone>

                <Row className="justify-content-center mt-4">
                    <Col sm="2">
                        <Button 
                            disabled={props.selectedFile.length === 0}
                            onClick={() => props.sendReport()}
                        >
                            {props.t('Potvrdi')}
                        </Button>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default DropFile;
